import { Box, EnhancedDimension, Skeleton, Text } from '@factorialco/deprecated-design-system'
import {
  ScheduleForSelectFragment,
  ScheduleSelectorDocument,
  ScheduleSelectorQuery,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import i18n from 'modules/core/lib/i18n'

const ScheduleItem = ({ schedule }: { schedule: ScheduleForSelectFragment }) => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center" key={schedule.id}>
      <Text.Normal size="300">{schedule.name}</Text.Normal>
    </Box>
  )
}

const ScheduleSkeleton = () => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Skeleton width="s240" height="s32" />
    </Box>
  )
}

interface Props {
  error?: string
  mandatory?: boolean
  disabled?: boolean
  width?: EnhancedDimension
  minWidth?: EnhancedDimension
  label?: string
  description?: string
  emptyLabel?: string
  value?: ScheduleForSelectFragment | null
  onSelect: (schedule: ScheduleForSelectFragment | null) => void
}

export const ScheduleSelector = ({
  error,
  mandatory,
  disabled = false,
  width,
  minWidth,
  label,
  description,
  emptyLabel,
  value,
  onSelect,
}: Props) => {
  const renderEntity = (entity: ScheduleForSelectFragment) => <ScheduleItem schedule={entity} />

  const renderSkeleton = () => <ScheduleSkeleton />

  const extractConnection = (data: ScheduleSelectorQuery) => {
    return data.workSchedule.schedulesConnection
  }

  const filterEntities = (entities: ScheduleForSelectFragment[]) => {
    return entities
  }

  return (
    <EntitySelector
      label={label}
      description={description}
      disabled={disabled}
      error={error}
      mandatory={mandatory}
      document={ScheduleSelectorDocument}
      variables={{}}
      width={width}
      minWidth={minWidth}
      extractConnection={extractConnection}
      renderEntity={renderEntity}
      value={value ?? null}
      onChange={onSelect}
      renderSkeleton={renderSkeleton}
      renderValue={(entity) => (
        <Text.Normal>
          {entity !== null
            ? entity.name
            : (emptyLabel ?? i18n.t('settings.work_schedule.select_schedule'))}
        </Text.Normal>
      )}
      filterEntities={filterEntities}
    />
  )
}
